import { Component, inject, input, viewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { ModalService } from '../../../services';
import { BaseFormComponent } from '../../base-form/base-form.component';
import { SummaryTopComponent } from '../../summary-top/summary-top.component';

@Component({
  selector: 'app-form-modal',
  templateUrl: './form-ok-modal.component.html',
  styleUrl: './form-ok-modal.component.scss',
  imports: [SummaryTopComponent, BaseFormComponent],
})
export class FormOkModalComponent {
  private readonly modalService = inject(ModalService);

  private readonly form = viewChild(BaseFormComponent);

  public readonly header = input<string>();
  public readonly message = input<string>();
  public readonly okLabel = input($localize`Ok`);
  public readonly fields = input<FormlyFieldConfig[]>();
  public readonly model = input<any>({});

  onOk() {
    if (this.form() && !this.form().validate()) {
      return;
    }
    this.modalService.close(this.model());
  }

  onCancel() {
    this.modalService.dismiss();
  }
}
